export const documentationSections = [
  {
    title: 'System Overview',
    fields: [
      {
        label: 'Intended purpose & context of use',
        placeholder:
          'Describe the tasks, domain, users, environment, and benefits. Clarify professional vs. consumer use; on-prem vs. cloud; availability regions.',
      },
      {
        label: 'Deployment scope and target population',
        placeholder:
          'Identify users and impacted persons/groups, geographies, and accessibility considerations.',
      },
      {
        label: 'Forms in which the system is placed / put into service',
        placeholder:
          'e.g. embedded software, downloadable package, SaaS/API, mobile or desktop application',
      },
      {
        label: 'Hardware / runtime environment',
        placeholder:
          'e.g. supported CPU, GPU, or TPU types, required memory, operating systems or containers, and any network or external service dependencies',
      },
      {
        label: 'If component of a product',
        placeholder:
          'Reference product technical file; insert photographs/illustrations of external features, markings, internal layout.',
      },
      {
        label: 'User interface overview',
        placeholder:
          'Screens, interactions, explanation/insight views, error handling',
      },
      {
        label: 'Instructions for Use (IFU)',
        placeholder:
          'Summarise capabilities, limitations, expected accuracy/robustness/cybersecurity levels, conditions that affect performance, and interpretation guidance. Provide link to full IFU.',
      },
    ],
  },
  {
    title: 'Design & Development',
    fields: [
      {
        label: 'Development methods & lifecycle',
        placeholder:
          'Describe development approach (CRISP-ML(Q), MLOps), use of pre-trained models or third-party tools with version and licence details, data protection by design/default, and model release strategy',
      },
      {
        label: 'Design specifications',
        placeholder:
          'Describe system logic and algorithm families with key design choices, optimisation goals and constraints, expected outputs and quality, and trade-offs between accuracy, robustness, cybersecurity, data governance, fairness, or human oversight',
      },
      {
        label: 'System architecture & compute',
        placeholder:
          'Describe the system architecture, e.g. component diagram, inter-component contracts/APIs and dependencies, fail-safes, and compute resources used for development, training, testing, and validation',
      },
      {
        label: 'Data requirements & datasets',
        placeholder:
          'Describe the data, e.g. training/validation/testing inputs, provenance, collection/consent, labelling and quality controls, and known gaps or limitations',
      },
      {
        label: 'Human oversight measures',
        placeholder:
          'Describe oversight, e.g. pre-deployment approvals, human-in/on-the-loop controls, output interpretation, safe use, and escalation or rollback paths',
      },
      {
        label: 'Pre‑determined changes (PDM) envelope',
        placeholder:
          'Describe learning and update policies, e.g. online or periodic updates, change windows and triggers, compliance safeguards, and model/config versions allowed without a new conformity assessment',
      },
      {
        label: 'Validation & testing',
        placeholder:
          'Describe test plans and sampling, dataset separation, metrics for accuracy, robustness, fairness, cybersecurity, non-discrimination checks, and test logs with results, acceptance criteria, and residual risks',
      },
      {
        label: 'Cybersecurity measures',
        placeholder:
          'e.g. threat model, security by design, SBOM, protections for data and models, supply chain, authentication/authorization, rate limiting, logging, and vulnerability management with incident response',
      },
    ],
  },
  {
    title: 'Lifecycle, Risk & Post-Market Assurance',
    fields: [
      {
        label: 'Performance Metrics',
        placeholder:
          'Describe metrics, e.g. justification for chosen metrics, thresholds, confidence intervals, degradation conditions, and post-deployment re-validation approach',
      },
      {
        label: 'Risk Management System',
        placeholder:
          'Describe risk management process overview, hazard sources, risk register with treatments and owners, and links to change management and the PDM envelope',
      },
      {
        label: 'Lifecycle Changes',
        placeholder:
          'Summarise relevant changes made by the provider across lifecycle; include impact analysis, re‑verification, and traceability to versions.',
      },
      {
        label: 'Standards & Specifications',
        placeholder:
          'Describe harmonised standards applied, alternative solutions used to meet requirements, and other technical specs mapped to Chapter III, Section 2',
      },
      {
        label: 'EU Declaration of Conformity',
        placeholder:
          'Link to the EU DoC (Article 47) when available or add a placeholder reference, and include links to the conformity assessment route and notified body interactions',
      },
      {
        label: 'Post‑Market Performance & Monitoring Plan',
        placeholder:
          'Describe post-market monitoring, including organisation, KPIs, feedback channels, incident reporting, and review or decommissioning plans',
      },
    ],
  },
];
